<template>
  <div class="query-topic">
    <loader_component v-if="is_loading" />
    <div v-else>
      <div class="mb-2 d-flex align-items-center">
        <span class="font-weight-bolder"> Query: </span>
        <span
          class="ml-auto clickable hoverable"
          @click="copyQuery"
          v-if="query"
        >
          {{ is_copy ? "Berhasil Disalin!" : "Salin" }}
          <i class="bi bi-copy" aria-hidden="true"></i>
        </span>
      </div>
      <div
        class="border rounded p-2"
        style="max-height: 20rem; overflow: auto"
        v-html="query ? emphasizeORWithStrong(query) : 'Tidak ada Query'"
      ></div>
    </div>
  </div>
</template>
<script>
import loader_component from "../../loader.vue";

export default {
  name: "modal_query_topic",
  components: {
    loader_component,
  },
  data() {
    return {
      is_loading: true,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : atob(this.$route.query.ref),
      data: this.$parent.data,
      query: null,
      is_copy: false,
    };
  },
  methods: {
    emphasizeORWithStrong: function (text) {
      var emphasizedText = text.replace(/( OR )/gi, "<strong>$1</strong>");
      return emphasizedText;
    },
    getQuery() {
      this.is_loading = true;
      const api = `${process.env.VUE_APP_API_URL}query-topic/${this.id_project}?id_topic=${this.data.id}&tipe=${this.data.tipe}`;
      this.$http
        .get(api)
        .then((res) => {
          this.query = res.data.query_topic;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    copyQuery() {
      navigator.clipboard.writeText(this.query).then(() => {
        this.is_copy = true;
        setTimeout(() => {
          this.is_copy = false;
        }, 3000);
      });
    },
  },
  created() {
    this.getQuery();
  },
};
</script>